import React from 'react';
import { useAppUserDefaultStore, isAllRestaurantsSelected } from '../../../stores/appUserDefaultStore';
import { ReportsGate } from '../reports/hub/ReportsGate';
import { ReportDetailLayout } from '../reports/hub/ReportDetailLayout';
import { getReportDefinition } from '../reports/hub/reportsRegistry';

/**
 * The utilization report exposed as its own top-level page (`/utilization`,
 * sidebar entry under Cost Price), available to every account without the
 * Reports hub — only invoice-only accounts are kept out, by the app-wide
 * `InvoiceOnlyRedirect` allowlist.
 * Reuses the exact same report body + shell as `/reports/utilization`; only the
 * back target differs. Both individual and organization-wide reports are supported.
 */
const ProductUtilizationPage: React.FC = () => {
  const restaurant = useAppUserDefaultStore(s => s.restaurant);
  const definition = getReportDefinition('utilization')!;
  const { Component } = definition;

  return (
    <ReportsGate requireReportsAccess={false} requireSingleRestaurant={!definition.supportsAllRestaurants}>
      <ReportDetailLayout
        independentHistory={isAllRestaurantsSelected(restaurant)}
        titleKey={definition.titleKey}
        overallTypeOptions={definition.overallTypeOptions}
        backTo="/dashboard"
      >
        <Component />
      </ReportDetailLayout>
    </ReportsGate>
  );
};

export default ProductUtilizationPage;
